webpackJsonp([0],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(5);
var Hello_1 = __webpack_require__(99);
var Home = (function (_super) {
    __extends(Home, _super);
    function Home(props, context) {
        return _super.call(this, props, context) || this;
    }
    Home.prototype.render = function () {
        return (React.createElement(Hello_1.default, { name: this.props.name }));
    };
    return Home;
}(React.Component));
exports.default = Home;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(105);
var React = __webpack_require__(5);
var View = function (props) { return (React.createElement("div", { id: "view1" },
    React.createElement("h3", null, props.message))); };
exports.default = function () { return React.createElement(View, { message: "This is View 1" }); };


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(5);
var View = function (props) { return (React.createElement("div", null,
    React.createElement("h3", null, props.message))); };
exports.default = function () { return React.createElement(View, { message: "This is View 2" }); };


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.36166adfacf0c8cc11d493f2161164fd.png";

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(5);
var cls = __webpack_require__(58);
var react_router_dom_1 = __webpack_require__(34);
var servicestack_client_1 = __webpack_require__(61);
exports.client = new servicestack_client_1.JsonServiceClient(global.BaseUrl || '/');
var NavItem = (function (_super) {
    __extends(NavItem, _super);
    function NavItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavItem.prototype.render = function () {
        var _a = this.props, to = _a.to, location = _a.location, children = _a.children, props = __rest(_a, ["to", "location", "children"]);
        var active = location.pathname === to;
        return (React.createElement("li", { role: "presentation", className: cls('nav-item', { active: active }) },
            React.createElement(react_router_dom_1.Link, { to: to, className: "nav-link" }, children)));
    };
    NavItem = __decorate([
        react_router_dom_1.withRouter
    ], NavItem);
    return NavItem;
}(React.Component));
exports.NavItem = NavItem;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(103);
__webpack_require__(104);
__webpack_require__(106);
__webpack_require__(59);
var ReactDOM = __webpack_require__(60);
var React = __webpack_require__(5);
var react_router_dom_1 = __webpack_require__(34);
var shared_1 = __webpack_require__(62);
var Home_1 = __webpack_require__(100);
var View_1 = __webpack_require__(101);
var View_2 = __webpack_require__(102);
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.render = function () {
        return (React.createElement(react_router_dom_1.BrowserRouter, null,
            React.createElement("div", null,
                React.createElement("nav", { className: "navbar navbar-toggleable-md navbar-inverse bg-inverse" },
                    React.createElement("div", { className: "container" },
                        React.createElement(react_router_dom_1.Link, { to: "/", className: "navbar-brand" },
                            React.createElement("i", { className: "fa fa-code", "aria-hidden": "true" }),
                            React.createElement("span", { style: { paddingLeft: 5 } }, "TrogTrialManagement")),
                        React.createElement("div", { className: "collapse navbar-collapse" },
                            React.createElement("ul", { className: "navbar-nav mr-auto" },
                                React.createElement(shared_1.NavItem, { to: "/" }, "Home"),
                                React.createElement(shared_1.NavItem, { to: "/view1" }, "View 1"),
                                React.createElement(shared_1.NavItem, { to: "/view2" }, "View 2"))))),
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row", style: { margin: "10px 0" } },
                        React.createElement("div", { id: "content" },
                            React.createElement(react_router_dom_1.Route, { exact: true, path: "/", render: function (props) { return React.createElement(Home_1.default, { name: "React" }); }, activeClassName: "active" }),
                            React.createElement(react_router_dom_1.Route, { path: "/view1", component: View_1.default, activeClassName: "active" }),
                            React.createElement(react_router_dom_1.Route, { path: "/view2", component: View_2.default, activeClassName: "active" })))),
                React.createElement("h4", { style: { position: 'absolute', bottom: 20, width: '100%', textAlign: 'center' } },
                    React.createElement("img", { src: __webpack_require__(108) }),
                    React.createElement("a", { href: "https://servicestack.net/vs-templates/ReactApp" }, "Learn about this React VS.NET template")))));
    };
    return App;
}(React.Component));
ReactDOM.render(React.createElement(App, null), document.getElementById("app"));


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* Options:
Date: 2017-07-03 16:24:54
Version: 4.512
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:2201/auth/identityserver

//GlobalNamespace:
//MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion:
//AddDescriptionAsComments: True
//IncludeTypes:
//ExcludeTypes:
//DefaultImports:
*/
Object.defineProperty(exports, "__esModule", { value: true });
// @DataContract
var ResponseError = (function () {
    function ResponseError() {
    }
    return ResponseError;
}());
exports.ResponseError = ResponseError;
// @DataContract
var ResponseStatus = (function () {
    function ResponseStatus() {
    }
    return ResponseStatus;
}());
exports.ResponseStatus = ResponseStatus;
var Membership = (function () {
    function Membership() {
    }
    return Membership;
}());
exports.Membership = Membership;
var UserTrialInstitution = (function () {
    function UserTrialInstitution() {
    }
    return UserTrialInstitution;
}());
exports.UserTrialInstitution = UserTrialInstitution;
var UserInstitution = (function () {
    function UserInstitution() {
    }
    return UserInstitution;
}());
exports.UserInstitution = UserInstitution;
var User = (function () {
    function User() {
    }
    return User;
}());
exports.User = User;
var UserDetails = (function () {
    function UserDetails() {
    }
    return UserDetails;
}());
exports.UserDetails = UserDetails;
var HelloResponse = (function () {
    function HelloResponse() {
    }
    return HelloResponse;
}());
exports.HelloResponse = HelloResponse;
var GetUserResponse = (function () {
    function GetUserResponse() {
    }
    return GetUserResponse;
}());
exports.GetUserResponse = GetUserResponse;
var GetAllUsersResponse = (function () {
    function GetAllUsersResponse() {
    }
    return GetAllUsersResponse;
}());
exports.GetAllUsersResponse = GetAllUsersResponse;
var GetUserDetailsResponse = (function () {
    function GetUserDetailsResponse() {
    }
    return GetUserDetailsResponse;
}());
exports.GetUserDetailsResponse = GetUserDetailsResponse;
// @DataContract
var AuthenticateResponse = (function () {
    function AuthenticateResponse() {
    }
    return AuthenticateResponse;
}());
exports.AuthenticateResponse = AuthenticateResponse;
// @DataContract
var AssignRolesResponse = (function () {
    function AssignRolesResponse() {
    }
    return AssignRolesResponse;
}());
exports.AssignRolesResponse = AssignRolesResponse;
// @DataContract
var UnAssignRolesResponse = (function () {
    function UnAssignRolesResponse() {
    }
    return UnAssignRolesResponse;
}());
exports.UnAssignRolesResponse = UnAssignRolesResponse;
// @Route("/hello")
// @Route("/hello/{Name}")
var Hello = (function () {
    function Hello() {
    }
    Hello.prototype.createResponse = function () { return new HelloResponse(); };
    Hello.prototype.getTypeName = function () { return "Hello"; };
    return Hello;
}());
exports.Hello = Hello;
// @Route("/user", "GET")
// @Route("/user/{Id}", "GET")
var GetUser = (function () {
    function GetUser() {
    }
    GetUser.prototype.createResponse = function () { return new GetUserResponse(); };
    GetUser.prototype.getTypeName = function () { return "GetUser"; };
    return GetUser;
}());
exports.GetUser = GetUser;
// @Route("/allusers", "GET")
var GetAllUsers = (function () {
    function GetAllUsers() {
    }
    GetAllUsers.prototype.createResponse = function () { return new GetAllUsersResponse(); };
    GetAllUsers.prototype.getTypeName = function () { return "GetAllUsers"; };
    return GetAllUsers;
}());
exports.GetAllUsers = GetAllUsers;
var GetUserDetails = (function () {
    function GetUserDetails() {
    }
    GetUserDetails.prototype.createResponse = function () { return new GetUserDetailsResponse(); };
    GetUserDetails.prototype.getTypeName = function () { return "GetUserDetails"; };
    return GetUserDetails;
}());
exports.GetUserDetails = GetUserDetails;
// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
var Authenticate = (function () {
    function Authenticate() {
    }
    Authenticate.prototype.createResponse = function () { return new AuthenticateResponse(); };
    Authenticate.prototype.getTypeName = function () { return "Authenticate"; };
    return Authenticate;
}());
exports.Authenticate = Authenticate;
// @Route("/assignroles")
// @DataContract
var AssignRoles = (function () {
    function AssignRoles() {
    }
    AssignRoles.prototype.createResponse = function () { return new AssignRolesResponse(); };
    AssignRoles.prototype.getTypeName = function () { return "AssignRoles"; };
    return AssignRoles;
}());
exports.AssignRoles = AssignRoles;
// @Route("/unassignroles")
// @DataContract
var UnAssignRoles = (function () {
    function UnAssignRoles() {
    }
    UnAssignRoles.prototype.createResponse = function () { return new UnAssignRolesResponse(); };
    UnAssignRoles.prototype.getTypeName = function () { return "UnAssignRoles"; };
    return UnAssignRoles;
}());
exports.UnAssignRoles = UnAssignRoles;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(107);
var React = __webpack_require__(5);
var shared_1 = __webpack_require__(62);
var dtos_1 = __webpack_require__(98);
var HelloComponent = (function (_super) {
    __extends(HelloComponent, _super);
    function HelloComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { result: '' };
        return _this;
    }
    HelloComponent.prototype.componentDidMount = function () {
        this.nameChanged(this.props.name);
    };
    HelloComponent.prototype.nameChanged = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var request, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!name) return [3 /*break*/, 2];
                        request = new dtos_1.Hello();
                        request.name = name;
                        return [4 /*yield*/, shared_1.client.get(request)];
                    case 1:
                        r = _a.sent();
                        this.setState({ result: r.result });
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState({ result: '' });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HelloComponent.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "form-group" },
            React.createElement("input", { className: "form-control", type: "text", placeholder: "Your name", defaultValue: this.props.name, onChange: function (e) { return _this.nameChanged(e.target.value); } }),
            React.createElement("h3", { className: "result" }, this.state.result)));
    };
    return HelloComponent;
}(React.Component));
exports.default = HelloComponent;


/***/ })

},[232]);


// WEBPACK FOOTER //
// app.87ffb5110e800b48add4.bundle.js